<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h4>Rechtliches</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <mat-card appearance="outlined" class="example-card" *ngFor="let legal of legalSections; let i = index;"
        style="margin-top: 35px;">
        <mat-card-title> {{ legal.title }} </mat-card-title>
        <mat-card-content>
          <ckeditor [editor]="Editor" [config]="config"
            style="display:inline-block;width: 100%;min-height: 350px;height: 450px;" [(ngModel)]="legalInformation[i]"
            (change)="legalEditorChanged($event, i);">
          </ckeditor>
          <button mat-raised-button color="primary" class="marginTop2Rem" (click)="showAsHtml = !showAsHtml">Als HTML
            anzeigen</button>
          <div class="row marginTop2Rem" *ngIf="showAsHtml">
            <div class="col-lg-12">
              <mat-form-field class="full-width">
                <mat-label>{{ legal.title }} (HTML):</mat-label>
                <textarea matInput [(ngModel)]="legalInformation[i]" rows="20" cols="80"></textarea>
              </mat-form-field>
            </div>
          </div>


        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-button color="primary" (click)="saveLegal(i, legal.key)" [disabled]="!legalHasChanged[i]">
            Änderungen Speichern
          </button>
        </mat-card-actions>

      </mat-card>
    </div>
  </div>
</div>